import { CalendarOff } from "lucide-react";
import { useTranslation } from "react-i18next";

export const OutOfOfficeBadge = () => {
  const { t } = useTranslation("team-chat");
  return (
    <span className="inline-flex items-center gap-1 text-amber-600">
      <CalendarOff className="h-3 w-3" />
      {t("out of office")}
    </span>
  );
};
